import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import TableComponent from "../../components/TableComponent";
import AdminLayout from "../../layouts/AdminLayouts";
import { faFolderOpen, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import RegisterTextarea from "../../components/RegisterTextarea";
import API from "../../api/axiosConfig";


function Organizations(props) {

    const columns = [
        { name: "إسم الجمعية", key: "name" },
        { name: " رقم التسجيل  ", key: "registration_number" },
        { name: "  العنوان", key: "address" },
        { name: "رقم الجوال", key: "phone" },
        { name: "   البريد الالكتروني", key: "email" },
        { name: "  ممثل الجمعية", key: "representative" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [note , setNote] = useState('');
    const [id, setId] = useState('');
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());


    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const dropdownOptions = [
        { label: "عرض", route: "/organizationshow/:id" },
        { label: " المديولات", route: "/organizationmodules/:id" },
        { label: " الطلبات", route: "/organizationrequests/:id" },
        { label: " حذف", action : (id, record) => { 
            setShowModal(true);
            setId(id);
        } },
    ];

    const HandleDlete = async () => {
        const formData = new FormData();    
        formData.append('note', note);
        try{
            const res = await API.post(`/organization/${id}/update/status/reject` , formData); 
            const data = await res;
            if (data.status === 200) {
                setShowModal(false);
                setTableReloadKey(Date.now());
            }
        }
        catch(error){
            console.log(error);
        }
    };

    return (
        <>
        <AdminLayout />
            <div className="printcasedata-container">

                <TableComponent
                    apiUrl="/organization/approved"
                    columns={columns}
                    title="تقرير الجمعيات"
                    titleIcon={<FontAwesomeIcon icon={faReceipt} />}
                    dropdownOptions={dropdownOptions}
                    searchDate={false}
                    placeholderSearch='إسم الجمعية'
                    triggerReload={tableReloadKey}
                />
            </div>

             <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="modal-table small-modall archModal"
                  dialogClassName="fit-content-modal"

            >
                <Modal.Header>
                    <Modal.Title>إضافة مديول</Modal.Title>
                    <Button
                        className="custom-close-button"
                        variant="link"
                        onClick={() => setShowModal(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} className="closeModal" />
                    </Button>
                </Modal.Header>
                <Modal.Body>
                     

                    <RegisterTextarea label="سبب الاستبعاد" value={note} onChange={(e) => setNote(e.target.value)} />
                   
                   
                  

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        إغلاق
                    </Button>
                    {
                        isSubmitting ? (
                            <Button variant="primary" disabled>
                                <Spinner animation="border" size="sm" />
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={HandleDlete}>
                                حفظ
                            </Button>
                        )
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Organizations;
